import { render, staticRenderFns } from "./MoldOrder.vue?vue&type=template&id=58952ea0&"
import script from "./MoldOrder.vue?vue&type=script&lang=js&"
export * from "./MoldOrder.vue?vue&type=script&lang=js&"
import style0 from "./MoldOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports